import { type ReactNode } from 'react'
import { cn } from '../../lib/utils'

const colorMap = {
  gray: 'bg-gray-100 text-gray-600',
  green: 'bg-green-100 text-green-700',
  blue: 'bg-blue-100 text-blue-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  red: 'bg-red-100 text-red-700',
  purple: 'bg-purple-100 text-purple-700',
  indigo: 'bg-indigo-100 text-indigo-700',
  amber: 'bg-amber-100 text-amber-700',
  emerald: 'bg-emerald-100 text-emerald-700',
  violet: 'bg-violet-100 text-violet-700',
  cyan: 'bg-cyan-100 text-cyan-700',
  orange: 'bg-orange-100 text-orange-700',
} as const

const sizeMap = {
  xs: 'px-2 py-0.5 text-xs',
  sm: 'px-2.5 py-1 text-xs',
} as const

export interface StatusBadgeProps {
  label: string
  color: keyof typeof colorMap
  icon?: ReactNode
  size?: 'xs' | 'sm'
}

export const StatusBadge = ({ label, color, icon, size = 'sm' }: StatusBadgeProps) => {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        sizeMap[size],
        colorMap[color],
      )}
    >
      {icon}
      {label}
    </span>
  )
}
